// extracted by mini-css-extract-plugin
module.exports = {"list":"SubwaysList-module__list___2Yo9-","applyClear":"SubwaysList-module__applyClear___MGRB6"};